import axios from 'axios';

const service = axios.create({
    timeout: 10000, // 请求超时时间
});

service.setBaseURL = function (newBaseURL) {
    this.defaults.baseURL = newBaseURL;
};

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        // 比如，可以在这里设置请求头的Authorization
        return config;
    },
    error => {
        // 对请求错误做些什么
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        // 可以在这里根据后端的返回状态码做一些统一的处理
        return response.data;
    },
    error => {
        // 对响应错误做点什么
        console.error('Response Error:', error);
        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/http/axios.js